import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";

import {
  DSSCard,
  DSSDevice,
  SiselseApis,
  SiselseCardAvailable,
  SiselseCardGroup,
  SiselseCardRequestElement,
  SiselseCardsTypesAndCost,
  SiselseClient,
  SiselseCondo,
  SiselsePerson,
  SiselseTicket,
  siselseTypePayments,
} from "src/app/interfaces/siselse";
import { AngularFirestore } from "@angular/fire/firestore";
import { Person } from "src/app/interfaces/dss";
import { Installation } from "src/app/interfaces/installation";
import { InstallationsManagerService } from "../installations-manager/installations-manager.service";
import {
  HikAcsDeviceInfo,
  HikAcsDeviceListResponse,
  HikDoorInfo,
  HikDoorListResponse,
  HikOpenDoorType,
  HikResponse,
} from "src/app/interfaces/hik";
@Injectable({
  providedIn: "root",
})
export class SiselseService {
  public clients: SiselseClient[] = [];
  public client: SiselseClient = null;
  public condos: SiselseCondo[] = [];
  public condo: SiselseCondo = null;
  public devices: DSSDevice[] = [];
  public devicesFew: DSSDevice[] = [];
  public device: DSSDevice = null;

  public hikDevices: HikAcsDeviceInfo[] = [];
  public hikDevice: HikAcsDeviceInfo = null;
  public hikDoors: HikDoorInfo[] = [];

  public installationSelect: Installation = null;

  private loadDevicesIntervalId: NodeJS.Timeout;
  siselse: SiselseApis = {
    url: "https://siselse.ddns.net/sipass/",
    clientes: "clientes.php?dataMain=clientes",
    clientesData: "clientesdata.php?dataMain=infocliente&element=",
    condominos: "condominos.php?dataMain=infocasas&element=",
    condominoData: "condominodata.php?dataMain=infocondomino&element=",
    personas: "personas.php?dataMain=infocasas&element=",
    personasUpdate: "updatepersons.php",
    dss: {
      devices: (type: string, cloud: boolean = false): string => {
        switch (type) {
          case "all":
            return cloud
              ? "getdevicestodalainfo_ii.php?dataMain=infodevices"
              : "getdevicestodalainfo.php?dataMain=infodevices";
          case "few":
            return "getdevices.php?dataMain=infodevices";
          case "status":
            return "devicestatus.php?dataMain=devicestatus&element=";
          default:
            return "";
        }
      },
      cards: {
        get: (cloud: boolean, clientId: string): string => {
          //console.log('cloud', cloud)
          return (
            "expirationcards.php?dataMain=expiration&element=" +
            clientId +
            (cloud ? this.siselse.server.cloud : this.siselse.server.site)
          );
        },
        set: (
          cloud: boolean,
          condoId: string,
          cards: string[],
          status: boolean,
        ): string => {
          //console.log('cloud set', cloud)
          let queryCards = "";
          if (cards && cards.length > 0) {
            cards.forEach((c) => {
              queryCards.length === 0
                ? (queryCards = c)
                : (queryCards += "," + c);
            });
            queryCards = "&idcards=" + queryCards;
          }
          return (
            "expirationcardsIDGO.php?dataMain=expirationidgo&idcasa=" +
            condoId +
            queryCards +
            (status
              ? this.siselse.status.activate
              : this.siselse.status.block) +
            (cloud ? this.siselse.server.cloud : this.siselse.server.site)
          );
        },
        setAll: (cloud: boolean, condoId: string, status: boolean): string => {
          //console.log('cloud all', cloud)
          return (
            "expirationcardsGO.php?dataMain=expirationgo&idcasa=" +
            condoId +
            (status
              ? this.siselse.status.activate
              : this.siselse.status.block) +
            (cloud ? this.siselse.server.cloud : this.siselse.server.site)
          );
        },
      },
      cardsRequest: {
        create: (
          clientId: string,
          condoId: string,
          CRE: SiselseCardRequestElement[],
          paymentType?: siselseTypePayments,
          image?: string,
        ): string => {
          let element = "";
          let urlPayment = "";
          let urlImg = "";
          if (paymentType === "cualquiera" || paymentType === "efectivo") {
            urlPayment += "&pt=PENDIENTE&pm=" + paymentType.toUpperCase();
          } else if (
            paymentType === "stripe" ||
            paymentType === "transferencia"
          ) {
            urlPayment += "&pt=PAGADO&pm=" + paymentType.toUpperCase();
          }
          if (image) urlImg = "&it=" + this.generateImageTokenUrl(image);

          if (CRE && CRE.length > 0) {
            CRE.forEach((c) => {
              element.length === 0
                ? (element = this.generateCardRequestElement(c))
                : (element += "," + this.generateCardRequestElement(c));
            });
            console.log(element);
            element = "&element=" + element;
          }
          const url =
            "tarjetasAgregaxCasa.php?dataMain=altatarjetas&ic=" +
            clientId +
            "&ih=" +
            condoId +
            element +
            urlImg +
            urlPayment;
          console.log(url);
          return url;
        },
        createByLote: (
          clientId: string,
          condoId: string,
          CRE: SiselseCardRequestElement[],
          paymentType?: siselseTypePayments,
          image?: string,
        ): string => {
          let element = "";
          let urlPayment = "";
          let urlImg = "";
          if (paymentType === "cualquiera" || paymentType === "efectivo") {
            urlPayment += "&pt=PENDIENTE&pm=" + paymentType.toUpperCase();
          } else if (
            paymentType === "stripe" ||
            paymentType === "transferencia" ||
            paymentType === "paid"
          ) {
            urlPayment += "&pt=PAGADO&pm=" + paymentType.toUpperCase();
          } else if (paymentType === "courtesy") {
            urlPayment += "&pt=CORTESIA&pm=CORTESIA"; // + paymentType.toUpperCase();
          }
          if (image) urlImg = "&it=" + this.generateImageTokenUrl(image);

          if (CRE && CRE.length > 0) {
            CRE.forEach((c) => {
              element.length === 0
                ? (element = this.generateCardRequestElementByLote(c))
                : (element += "," + this.generateCardRequestElementByLote(c));
            });
            console.log(element);
            element = "&element=" + element;
          }
          /*  ic -> IDPRIVADA
          ih -> IDCASA
          pt -> TIPO DE PAGO
          pm -> MÉTODO DE PAGO
          it -> ID COMPROBANTE DE PAGO */
          const url =
            "tarjetasAgregaxCasaLote.php?dataMain=altatarjetas&ic=" +
            clientId +
            "&ih=" +
            condoId +
            element +
            urlImg +
            urlPayment;
          console.log(url);
          return url;
        },
        activates: (clientId: string): string => {
          return (
            "tarjetasActivadasxZona.php?dataMain=tarjetasxzona&idcliente=" +
            clientId
          );
        },
        available: (clientId: string): string => {
          return (
            "tarjetasDisponiblesxZona.php?dataMain=tarjetasxzona&idcliente=" +
            clientId
          );
        },
        requestAll: (date: string): string => {
          // return 'tarjetasSolicitudesxCliente.php?dataMain=solicitudesxcliente&idcliente=' + clientId;
          return (
            "tarjetasStatusxFecha.php?dataMain=tarjetasStatusxFecha&periodo=" +
            date
          );
        },
        requestAllByClient: (clientId: string): string => {
          // return 'tarjetasSolicitudesxCliente.php?dataMain=solicitudesxcliente&idcliente=' + clientId;
          return (
            "tarjetasStatusxCliente.php?dataMain=tarjetasStatusxCliente&idcliente=" +
            clientId
          );
        },
        groups: (clientId: string): string => {
          return (
            "tarjetasGruposxCliente.php?dataMain=gruposcliente&element=" +
            clientId
          );
        },
        typesAndCosts: (clientId: string): string => {
          return (
            "tarjetasTiposxCliente.php?dataMain=tarjetasTiposxCliente&idcliente=" +
            clientId
          );
        },
      },
      relays: {
        open: (cloud: boolean, channelCode: string): string => {
          //console.log('cloud', cloud)
          return (
            "opendoor.php?dataMain=openrelay&element=" +
            channelCode +
            (cloud ? this.siselse.server.cloud : this.siselse.server.site)
          );
        },
      },
    },
    hik: {
      url: "https://siselse.ddns.net/hik/api/",
      devices: {
        all: (): string => {
          return this.siselse.hik.url + "getdevices.php";
        },
        doors: {
          get: (deviceCode: string): string => {
            return this.siselse.hik.url + "getdoors.php?dev=" + deviceCode;
          },
          open: (
            deviceCode: string,
            doorId: string,
            typeOpen: string,
          ): string => {
            return (
              this.siselse.hik.url +
              "open.php?device=" +
              deviceCode +
              "&door=" +
              doorId +
              "&type=" +
              typeOpen
            );
          },
          openWithOptions: (options: any): string => {
            return (
              this.siselse.hik.url +
              "opendoor.php?device=" +
              options.deviceCode +
              "&door=" +
              options.doorId +
              "&type=" +
              options.typeOpen
            );
          },
        },
      },
    },
    status: {
      activate: "&status=ACTIVAR",
      block: "&status=BLOQUEAR",
    },
    server: {
      cloud: "&server=CLOUD",
      site: "&server=SITE",
    },
    tickets: {
      all: (clientId: string): string => {
        return "tickets_list.php?dataMain=listatickets&idcliente=" + clientId;
      },
      detail: (ticketId: string): string => {
        return (
          "tickets_detail.php?dataMain=detalletickets&idticket=" + ticketId
        );
      },
      add: (
        clientId: string,
        data: string,
        cause: "56" | "57" = "56",
      ): string => {
        // 56 = Técnica, 57 = Administrativa
        return (
          "tickets_new.php?dataMain=nuevoticket&idcliente=" +
          clientId +
          "&causa=" +
          cause +
          "&incidencia=" +
          encodeURIComponent(data)
        );
      },
    },
    client: {
      commentSet: (clientId: string, comment: string): string => {
        return (
          "comments.php?dataMain=comment&idcliente=" +
          clientId +
          "&comentario=" +
          encodeURIComponent(comment)
        );
      },
    },
    relayOpen: "opendoor.php?dataMain=openrelay&element=",
    expirationCards: "expirationcardsAll.php?dataMain=expiration&element=", //carga 1 casa todas sus tarjetas
    expirationcardsIDGO:
      "expirationcardsIDGO.php?dataMain=expirationidgo&idcasa=", // actualiza una o varias tarjetas de la casa bloquear o desblosquear
    condominoCards: "expirationcardsGO.php?dataMain=expirationgo&idcasa=", // actualiza todas las tarjetas de una casa bloquear o desblosquear
    condominoDefaulter:
      "changestatuscasa.php?dataMain=changestatuscasa&idcasa=",
  };

  constructor(
    private apiServ: ApiService,
    private afs: AngularFirestore,
  ) {
    // this.loadClients();
  }

  setClientSiselse(id: string) {
    let temp = this.clients.filter((item) => item.id === id);
    this.client = temp.length === 1 ? temp[0] : null;
    if (this.client) this.loadCondos(this.client.id);
  }

  setCondoSiselse(id: string) {
    let temp = this.condos.filter((item) => item.idcasa === id);
    this.condo = temp.length === 1 ? temp[0] : null;
  }

  //Client

  private async commentClient(clientId: string, comment: string) {
    return this.apiServ.get(
      this.siselse.url + this.siselse.client.commentSet(clientId, comment),
    );
  }

  async commentClientSet(clientId: string, comment: string): Promise<any> {
    const res = (await this.commentClient(clientId, comment)).toPromise();
    // if (res && res["success"] && res["result"]) tickets = res["result"];
    return res;
  }

  // Persons
  loadPersons(id: string) {
    return this.apiServ.get(this.siselse.url + this.siselse.personas + id);
  }
  async getPersons(id: string): Promise<SiselsePerson[]> {
    let persons = [];
    const res = await this.loadPersons(id).toPromise();
    if (res && res["success"] && res["result"]) persons = res["result"];
    return persons;
  }

  async setPersons(
    idCasa: string,
    typePerson: "habitant" | "frequent" | "condomino",
    persons: SiselsePerson[],
  ): Promise<any> {
    const res = await this.apiServ
      .getJson(this.siselse.url + this.siselse.personasUpdate, {
        idcasa: idCasa,
        tipocondomino:
          typePerson === "condomino"
            ? "1"
            : typePerson === "habitant"
              ? "2"
              : "3",
        persons: JSON.stringify(persons),
        dataMain: "updatepersons",
      })
      .toPromise();
    return res;
  }

  // Clients
  loadClients() {
    // console.log("load clients");
    this.apiServ
      .get(this.siselse.url + this.siselse.clientes)
      .subscribe((res) => {
        console.log(res);
        if (res["result"]) this.clients = res["result"];
      });
  }

  loadClient(id: string) {
    return this.apiServ.get(this.siselse.url + this.siselse.clientesData + id);
  }

  async getClient(id: string): Promise<SiselseClient> {
    this.client = null;
    const res = await this.loadClient(id).toPromise();
    if (res && res["success"] && res["result"].length === 1)
      this.client = res["result"][0];
    return this.client;
  }

  //Condos
  loadCondos(id: string) {
    // console.log("load Condos");
    this.condos = [];
    this.apiServ
      .get(this.siselse.url + this.siselse.condominos + id)
      .subscribe((res) => {
        //console.log(res);
        if (res["result"]) this.condos = res["result"];
        if (this.condos.length)
          this.condos.forEach((c) => {
            c.calle =
              c.calle &&
              c.calle.toLocaleLowerCase() !== "null" &&
              c.calle.trim() !== ""
                ? c.calle
                : "";
            c.numero =
              c.numero &&
              c.numero.toLocaleLowerCase() !== "null" &&
              c.calle.trim() !== ""
                ? c.numero
                : "";
            c["tempCalle"] = c.calle
              .toLowerCase()
              .replace(/[^A-Z^a-z0-9]/gi, "");
            c["tempNumero"] = c.numero
              .toLowerCase()
              .replace(/[^A-Z^a-z0-9]/gi, "");
          });
      });
  }

  loadCondo(id: string) {
    return this.apiServ.get(this.siselse.url + this.siselse.condominoData + id);
  }

  async getCondo(id: string): Promise<SiselseCondo> {
    this.condo = null;
    const res = await this.loadCondo(id).toPromise();
    if (res && res["success"] && res["result"].length === 1)
      this.condo = res["result"][0];
    return this.condo;
  }

  async setStatusCondo(
    id: string,
    status: boolean,
    street?: string,
    number?: string,
    int1?: string,
    int2?: string,
    correo1?: string,
  ): Promise<{ idcasa: string; status: "Normal" | "Moroso" }[]> {
    let condo: { idcasa: string; status: "Normal" | "Moroso" }[] = [];
    const url = `${this.siselse.url}${this.siselse.condominoDefaulter}${id}${
      status ? this.siselse.status.activate : this.siselse.status.block
    }${street ? `&calle=${street}` : ""}${number ? `&numero=${number}` : ""}${
      correo1 ? `&correo1=${correo1}` : ""
    }${int1 ? `&in1=${int1}` : ""}${int2 ? `&in2=${int2}` : ""}`;

    const res = await this.apiServ.get(url).toPromise();
    console.log(res);
    if (res && res["success"] && res["result"].length > 0)
      condo = res["result"];
    return condo;
  }

  async updateAllResidents(id: string, status: boolean) {
    let res = await this.apiServ
      .post(
        "siselse/defaulter/place",
        { sp: id, s: status ? "activate" : "block" },
        null,
        "apiV2b",
      )
      .toPromise();
    console.log(res);
  }

  // Cards
  /*  loadCards(id: string) {
    return this.apiServ.get(
      this.siselse.url + this.siselse.expirationCards + id
    ); 
  }
  //carga las tarjetas de un condomino
  async getCards(id: string): Promise<DSSCard[]> {
    let cards = [];
    const res = await this.loadCards(id).toPromise();
    console.log(res);
    if (res["code"] === 1000) cards = res["data"]["pageData"];
    return cards;
  } */

  // Cards

  // Encuentra un servidor por la instalación
  async findServerByInstallation(installationId: string): Promise<boolean> {
    // Obtén la colección
    const terminalsCollection = this.afs.collection("devices/dss/terminals");

    // Obtén la referencia del documento\
    const installationRef = this.afs
      .collection("installations")
      .doc(installationId).ref;
    // Busca el primer documento que tenga la referencia de la instalación
    const snapshot = await terminalsCollection.ref
      .where("installation.ref", "==", installationRef)
      .limit(1)
      .get();
    // Si se encontró un documento y dss.server es 'CLOUD', devuelve true
    if (
      !snapshot.empty &&
      (snapshot.docs[0].data() as any).dss?.server === "SITE"
    ) {
      return false;
    }
    /* else if (this.installationSelect?.siselse?.serverdss === 'NUBE') {
      return true;
    } */
    // En caso contrario, devuelve false
    return true;
  }

  // carga las tarjetas de un condomino
  async loadCardsDSS(id: string, installationId: string) {
    return this.apiServ.get(
      this.siselse.url +
        this.siselse.dss.cards.get(
          await this.findServerByInstallation(installationId),
          id,
        ),
    );
  }

  //regresa las tarjetas de un condomino
  async getCardsDSS(id: string, installationId: string): Promise<Person[]> {
    let cards = [];
    let res = await (await this.loadCardsDSS(id, installationId)).toPromise();
    // console.log(res);
    if (res && res["success"] === true) {
      let cardsData = res["result"];
      if (cardsData) {
        cardsData.forEach((c) => {
          //console.log(c)
          if (c["code"] === 1000) {
            cards.push(c["data"]);
          }
        });
      }
    }

    // if (res["code"] === 1000) cards = res["data"]["pageData"];
    return cards;
  }

  // Actualiza todas las tarjetas de un condomino
  async setCardAllByCondoDss(
    id: string,
    installationId: string,
    status: boolean,
  ): Promise<{ idcasa: string; idcard: string; status: string }[]> {
    let cards: { idcasa: string; idcard: string; status: string }[] = [];
    let res = await (
      await this.apiServ.get(
        this.siselse.url +
          this.siselse.dss.cards.setAll(
            await this.findServerByInstallation(installationId),
            id,
            status,
          ),
      )
    ).toPromise();
    if (res && res["success"] && res["result"].length === 1)
      cards = res["result"];
    return cards;
  }

  // Actualiza todas las tarjetas de un condomino
  /*  async setStatusCard(
    id: string,
    status: boolean
  ): Promise<{ idcasa: string; idcard: string; status: string }[]> {
    let cards: { idcasa: string; idcard: string; status: string }[] = [];

    const res = await this.apiServ
      .get(
        this.siselse.url +
        this.siselse.condominoCards +
        id +
        (status ? this.siselse.status.activate : this.siselse.status.block)
      )
      .toPromise();
    if (res && res["success"] && res["result"].length === 1) cards = res["result"];
    return cards;
  } */

  // Actualiza todas las tarjetas de un condomino
  async setCardsByCondoDss(
    id: string,
    installationId: string,
    status: boolean,
    tCards: string[],
  ): Promise<{ idcasa: string; idcard: string; status: string }[]> {
    let cards: { idcasa: string; idcard: string; status: string }[] = [];
    let res = await (
      await this.apiServ.get(
        this.siselse.url +
          this.siselse.dss.cards.set(
            await this.findServerByInstallation(installationId),
            id,
            tCards,
            status,
          ),
      )
    ).toPromise();
    if (res && res["success"] && res["result"].length === 1)
      cards = res["result"];
    return cards;
  }

  //Actualiza todas las tarjetas
  async setStatusCards(
    id: string,
    status: boolean,
    tCards: string[],
  ): Promise<{ idcasa: string; idcard: string; status: string }[]> {
    let cards: { idcasa: string; idcard: string; status: string }[] = [];
    let queryCards = "";
    if (tCards && tCards.length > 0) {
      tCards.forEach((c) => {
        queryCards.length === 0 ? (queryCards = c) : (queryCards += "," + c);
      });
      queryCards = "&idcards=" + queryCards;
      //console.log(queryCards);
      const res = await this.apiServ
        .get(
          this.siselse.url +
            this.siselse.expirationcardsIDGO +
            id +
            queryCards +
            (status ? this.siselse.status.activate : this.siselse.status.block),
        )
        .toPromise();
      if (res && res["success"] && res["result"].length === 1)
        cards = res["result"];
    }

    return cards;
  }

  // Devices

  loadAllFewDevices() {
    if (this.devicesFew.length > 0) return;
    this.apiServ
      .get(this.siselse.url + this.siselse.dss.devices("few", true))
      .subscribe((res) => {
        //console.log(res);
        if (
          res &&
          res["success"] &&
          res["result"]["code"] === 1000 &&
          res["result"]["data"]["devices"]
        )
          this.devicesFew = res["result"]["data"]["devices"];
        //console.log(this.devicesFew);
      });
  }

  loadAllDevices(cloud: boolean = false) {
    console.log("loadAllDevices");
    console.log("cloud", cloud);
    // if (this.devices.length > 0) return;
    this.apiServ
      .get(this.siselse.url + this.siselse.dss.devices("all", cloud))
      .subscribe((res) => {
        //console.log(res);
        if (
          res &&
          res["success"] &&
          res["result"]["code"] === 1000 &&
          res["result"]["data"]["devices"]
        )
          this.devices = res["result"]["data"]["devices"];
        this.devices.sort((a, b) => a.name.localeCompare(b.name));
        //console.log(this.devices);
      });
  }

  loadDevices(
    devices: string[],
    installationId: string,
  ): Promise<{ deviceCode: string | null; status: 0 | 1 | null }[]> {
    return new Promise(async (resolve) => {
      console.log("load devices");
      console.log(devices);
      let tempDevices = "";
      if (devices.length > 0) {
        devices.forEach((d) => {
          tempDevices.length === 0
            ? (tempDevices = d)
            : (tempDevices += "," + d);
        });
        this.apiServ
          .get(
            this.siselse.url +
              this.siselse.dss.devices(
                "status",
                await this.findServerByInstallation(installationId),
              ) +
              tempDevices,
          )
          .subscribe((res) => {
            if (res["success"] && res["result"]) resolve(res["result"]);
            else resolve([]);
          });
      } else {
        resolve([]);
      }
    });
  }

  // Relay
  async openRelay(channelCode: string, cloud: boolean = true): Promise<any> {
    return await this.apiServ
      .get(this.siselse.url + this.siselse.dss.relays.open(cloud, channelCode))
      .toPromise();

    /*   return this.apiServ.get(
      this.siselse.url + this.siselse.relayOpen + channelCode
    ); */
  }

  //

  filterDevicesDSS(filter: string, cloud: boolean = true): DSSDevice[] {
    filter = filter.toLowerCase();
    if (filter.length === 0) {
      return this.devices.filter((item) => item.name !== "");
    }
    if (this.devices.length === 0) this.loadAllDevices(cloud);

    if (this.loadDevicesIntervalId) {
      clearInterval(this.loadDevicesIntervalId);
    }

    this.loadDevicesIntervalId = setInterval(
      () => this.loadAllDevices(cloud),
      900000,
    );

    const strFrontCode = filter.slice(0, filter.length - 1);
    const strEndCode = filter.slice(filter.length - 1, filter.length);

    const startCode = filter;
    const endCode =
      strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);

    return this.devices.filter(
      (item) =>
        (item.name.toLowerCase() >= startCode &&
          item.name.toLowerCase() <= endCode) ||
        (item.code.toLowerCase() >= startCode &&
          item.code.toLowerCase() <= endCode) ||
        item.name.toLowerCase().includes(filter) ||
        item.code.toLowerCase().includes(filter),
    );
  }

  // Tickets
  loadTickets(id: string) {
    return this.apiServ.get(this.siselse.url + this.siselse.tickets.all(id));
  }

  async getTickets(id: string): Promise<SiselseTicket[]> {
    let tickets = [];
    const res = await this.loadTickets(id).toPromise();
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  loadTicket(id: string) {
    return this.apiServ.get(this.siselse.url + this.siselse.tickets.detail(id));
  }

  async getTicketInfo(id: string): Promise<SiselseTicket[]> {
    let tickets = [];
    const res = await this.loadTicket(id).toPromise();
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  addTicket(clientId: string, detail: string, cause: "56" | "57" = "56") {
    return this.apiServ.get(
      this.siselse.url + this.siselse.tickets.add(clientId, detail, cause),
    );
  }

  async getAddTicket(
    clientId: string,
    detail: string,
    cause: "56" | "57" = "56",
  ): Promise<{ numticket: string; registro: string; nombre_area?: string }[]> {
    let tickets: { numticket: string; registro: string }[] = [];
    const res = await this.addTicket(clientId, detail, cause).toPromise();
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  // Cards Request
  loadAllCardsRequest(date: string) {
    return this.apiServ.get(
      this.siselse.url + this.siselse.dss.cardsRequest.requestAll(date),
    );
  }

  async getAllCardsRequest(date: string): Promise<SiselseCardAvailable[]> {
    // console.log("getAllCardsRequest", date);
    let tickets = [];
    const res = await this.loadAllCardsRequest(date).toPromise();
    // console.log(res);
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  loadCardsRequest(id: string) {
    return this.apiServ.get(
      this.siselse.url + this.siselse.dss.cardsRequest.requestAllByClient(id),
    );
  }

  async getCardsRequest(id: string): Promise<SiselseCardAvailable[]> {
    let tickets = [];
    const res = await this.loadCardsRequest(id).toPromise();
    // console.log(res);
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  activatesCardsRequest(id: string) {
    return this.apiServ.get(
      this.siselse.url + this.siselse.dss.cardsRequest.activates(id),
    );
  }

  async getActivatesCardsRequest(id: string): Promise<SiselseCardAvailable[]> {
    let tickets = [];
    const res = await this.activatesCardsRequest(id).toPromise();
    // console.log(res);
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  availableCardsRequest(id: string) {
    return this.apiServ.get(
      this.siselse.url + this.siselse.dss.cardsRequest.available(id),
    );
  }

  async getAvailableCardsRequest(id: string): Promise<SiselseCardAvailable[]> {
    let tickets = [];
    const res = await this.availableCardsRequest(id).toPromise();
    // console.log(res);
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  typesAndCostsCardsRequest(id: string) {
    return this.apiServ.get(
      this.siselse.url + this.siselse.dss.cardsRequest.typesAndCosts(id),
    );
  }

  async getTypesAndCostsCardsRequest(
    id: string,
  ): Promise<SiselseCardsTypesAndCost[]> {
    let tickets = [];
    const res = await this.typesAndCostsCardsRequest(id).toPromise();
    // console.log(res);
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  groupsCardsRequest(id: string) {
    return this.apiServ.get(
      this.siselse.url + this.siselse.dss.cardsRequest.groups(id),
    );
  }

  async getGroupsCardsRequest(id: string): Promise<SiselseCardGroup[]> {
    let tickets = [];
    const res = await this.groupsCardsRequest(id).toPromise();
    // console.log(res);
    if (res && res["success"] && res["result"]) tickets = res["result"];
    return tickets;
  }

  addCardRequest(
    clientId: string,
    condoId: string,
    CRE: SiselseCardRequestElement[],
    typePayment: siselseTypePayments,
    imgUrl: string = null,
  ) {
    return this.apiServ.get(
      this.siselse.url +
        this.siselse.dss.cardsRequest.createByLote(
          clientId,
          condoId,
          CRE,
          typePayment,
          imgUrl,
        ),
    );
  }

  async getAddCardRequest(
    clientId: string,
    condoId: string,
    CRE: SiselseCardRequestElement[],
    typePayment: siselseTypePayments,
    imgUrl: string = null,
  ): Promise<{ tarjeta: string; msg: string }[]> {
    let cardResponse: { tarjeta: string; msg: string }[] = [];
    const res = await this.addCardRequest(
      clientId,
      condoId,
      CRE,
      typePayment,
      imgUrl,
    ).toPromise();
    console.log(res);
    if (res && res["success"] && res["result"]) cardResponse = res["result"];
    return cardResponse;
  }

  generateCardRequestElement(CRE: SiselseCardRequestElement): string {
    //001003041001|ZONA%20DORADA%20CONDOMINOS|1|5|1
    //orgCode|orgName|authority|cardType|cardCount
    return `${CRE.orgCode}|${encodeURIComponent(CRE.orgName)}|${
      CRE.authority
    }|${CRE.cardType}|${CRE.cardCount}|${CRE.cost}`;
  }

  generateCardRequestElementByLote(CRE: SiselseCardRequestElement): string {
    /* element:
    [0] = ID DE GRUPO EN DSS
    [1] = NOMBRE DE GRUPO EN DSS
    [2] = AUTORIDAD O HERENCIA (CASI SIEMPRE 1)
    [3] = TIPO DE TARJETA
    [4] = UUID (ID DE TARJETA)
    [5] = COSTO
     */
    return `${CRE.orgCode}|${encodeURIComponent(CRE.orgName)}|${
      CRE.authority
    }|${CRE.cardType}|${CRE.cardUUID}|${CRE.cost}`;
  }

  generateImageTokenUrl(url) {
    // Parte fija de la URL para identificar el inicio de los datos de interés
    const parteFija =
      "https://firebasestorage.googleapis.com/v0/b/sipass.appspot.com/o/public%2Fvouchers%2Fcards-request%";

    // Extraer la parte de la URL que sigue después de la parte fija
    const datosRelevantes = url.substring(
      parteFija.length,
      url.indexOf(".jpg?alt=media&token="),
    );

    // Dividir los datos relevantes por "-" para obtener el número y el nombre del archivo
    const partes = datosRelevantes.split("-");
    // const numero1 = partes[0]; // Primer número
    // const numero2 = partes[1]; // Segundo número
    const nombreArchivo = partes[2]; // Nombre del archivo

    // Extraer el token dividiendo la URL por "token=" y tomando la segunda parte
    const token = url.split("token=")[1];
    console.log(nombreArchivo + "|" + token);

    return nombreArchivo + "|" + token;
  }

  filterCondos(filter: string): SiselseCondo[] {
    filter = filter.toLowerCase();
    if (filter.length === 0) {
      return this.condos.map((items) =>
        items.filter((item) => item.numero !== ""),
      );
    }
    const strFrontCode = filter.slice(0, filter.length - 1);
    const strEndCode = filter.slice(filter.length - 1, filter.length);

    const startCode = filter;
    const endCode =
      strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);

    // return this.CondosCollection.ref.where('name', '>=', startCode).where('name', '<', endCode).get();

    return this.condos.filter(
      (item) =>
        (item.calle.toLowerCase() >= startCode &&
          item.calle.toLowerCase() <= endCode) ||
        item.calle.toLowerCase().includes(filter) ||
        (item.numero.toLowerCase() >= startCode &&
          item.numero.toLowerCase() <= endCode) ||
        item.numero.toLowerCase().includes(filter) ||
        (item.frentecalle &&
          item.frentecalle.toLowerCase() >= startCode &&
          item.frentecalle.toLowerCase() <= endCode) ||
        (item.frentecalle && item.frentecalle.toLowerCase().includes(filter)) ||
        (item.frentecalle2 &&
          item.frentecalle2.toLowerCase() >= startCode &&
          item.frentecalle2.toLowerCase() <= endCode) ||
        (item.frentecalle2 && item.frentecalle2.toLowerCase().includes(filter)),
    );
  }

  async filterDeviceHik(filter: string): Promise<HikAcsDeviceInfo[]> {
    filter = filter.toLowerCase();
    if (filter.length === 0 && this.hikDevices.length != 0) {
      return this.hikDevices.filter((item) => item.acsDevName !== "");
    }
    if (this.hikDevices.length === 0) await this.loadAllHikDevices();

    if (this.loadDevicesIntervalId) {
      clearInterval(this.loadDevicesIntervalId);
    }

    this.loadDevicesIntervalId = setInterval(
      () => this.loadAllHikDevices(),
      900000,
    );

    const strFrontCode = filter.slice(0, filter.length - 1);
    const strEndCode = filter.slice(filter.length - 1, filter.length);

    const startCode = filter;
    const endCode =
      strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);

    console.log("HIK devices filter loaded:", this.hikDevices);
    return this.hikDevices.filter(
      (item) =>
        (item.acsDevName.toLowerCase() >= startCode &&
          item.acsDevName.toLowerCase() <= endCode) ||
        (item.acsDevCode.toLowerCase() >= startCode &&
          item.acsDevCode.toLowerCase() <= endCode) ||
        item.acsDevName.toLowerCase().includes(filter) ||
        item.acsDevCode.toLowerCase().includes(filter),
    );
  }

  async loadAllHikDevices(): Promise<void> {
    console.log("loadAllHikDevices");
    console.log("load hik devices", this.siselse.hik.devices.all());

    try {
      const res = await this.apiServ
        .get(this.siselse.hik.devices.all())
        .toPromise();
      console.log("Raw response:", res);

      let hikResponse = res as unknown as HikAcsDeviceListResponse;

      // Check if it has the HIK API structure (code/data)
      if (hikResponse.code === "0" && hikResponse.data.list) {
        this.hikDevices = hikResponse.data.list || [];
      } else {
        console.warn(
          "Unexpected HIK API response structure:",
          hikResponse.code,
        );
        this.hikDevices = [];
      }

      this.hikDevices.sort((a, b) =>
        (a.acsDevName || "").localeCompare(b.acsDevName || ""),
      );
      console.log("HIK devices loaded:", this.hikDevices);
    } catch (error) {
      console.error("Error loading HIK devices:", error);
      this.hikDevices = [];
    }
  }

  async loadDoorByDeviceHik(deviceIndex: string): Promise<HikDoorInfo[]> {
    console.log("loadDoorByDeviceHik", deviceIndex);
    let doors: HikDoorInfo[] = [];

    try {
      // Si no existen puertas cargadas, hacer la consulta
      if (this.hikDoors.length === 0) {
        const res = await this.apiServ
          .get(this.siselse.hik.devices.doors.get(deviceIndex))
          .toPromise();

        console.log("Raw response:", res);

        let hikResponse = res as unknown as HikDoorListResponse;

        // Check if it has the HIK API structure (code/data)
        if (hikResponse.code === "0" && hikResponse.data.list) {
          this.hikDoors = hikResponse.data.list || [];
        } else {
          console.warn(
            "Unexpected HIK API response structure:",
            hikResponse.code,
          );
          this.hikDoors = [];
        }

        console.log("HIK doors loaded from API:", this.hikDoors);
      }

      // Filtrar las puertas por acsDevIndexCode que coincida con deviceIndex
      doors = this.hikDoors.filter(
        (door) => door.acsDevIndexCode === deviceIndex,
      );

      console.log("HIK doors filtered for device:", deviceIndex, doors);
    } catch (error) {
      console.error("Error loading HIK doors:", error);
      doors = [];
    }

    return doors;
  }

  // Relay
  async openDoorHik(deviceIndex: string, door: string): Promise<any> {
    // Use the correct HikOpenDoorType value, for example 'remote' or 'card' depending on your definition
    // Replace 'remote' with the actual value you want to use
    return await this.apiServ
      .get(
        this.siselse.hik.devices.doors.open(
          deviceIndex,
          door,
          HikOpenDoorType.OPEN,
        ),
      )
      .toPromise();

    /*   return this.apiServ.get(
      this.siselse.url + this.siselse.relayOpen + channelCode
    ); */
  }
}
